// 連結帶入的預填訊息：?prerequestText=<文字>，只填進新對話的輸入框，不會自動送出。
// 網址帶了對話 id（#/c/<id>）就丟棄；讀過一次就從網址清掉，重新整理不會再填。
export const PREFILL_TEXT_PARAM = 'prerequestText'

export const parseLaunchPrefill = (search: string): string | null => {
  const text = (new URLSearchParams(search).get(PREFILL_TEXT_PARAM) ?? '').trim()
  return text || null
}

// 拿掉預填參數後的網址（其他 query 與 hash 保留）；本來就沒有就回 null，不必改網址
export const stripLaunchParams = (href: string): string | null => {
  const url = new URL(href)
  if (!url.searchParams.has(PREFILL_TEXT_PARAM)) return null
  url.searchParams.delete(PREFILL_TEXT_PARAM)
  return `${url.pathname}${url.search}${url.hash}`
}

export const consumeLaunchPrefill = (isNewChat: boolean): string | null => {
  const prefill = isNewChat ? parseLaunchPrefill(window.location.search) : null
  const cleaned = stripLaunchParams(window.location.href)
  if (cleaned !== null) window.history.replaceState(window.history.state, '', cleaned)
  return prefill
}
